import React, { useState } from "react";
import type { ViewComponent } from "@frui.ts/views";
import { registerView, View } from "@frui.ts/views";
import { observer, Observer } from "mobx-react-lite";
import AdministrationViewModel from "../../viewModels/administration/administrationViewModel";
import EnforcementViewModel from "../../viewModels/enforcement/enforcementViewModel";
import FinanceViewModel from "../../viewModels/finance/financeViewModel";
import TimeChargesViewModel from "../../viewModels/timeCharges/timeChargesViewModel";
import type { IModuleViewModel } from "../../viewModels/types";
import UsersModuleViewModel from "../../viewModels/users/usersModuleViewModel";
import SideMenu from "../common/sidemenu";
import Navbar from "react-bootstrap/Navbar";
import styles from "components/AppModule/appModule.module.scss";

const ModuleView: ViewComponent<IModuleViewModel> = observer(({ vm }) => {
  const [open, toggleSidebar] = useState(false);

  return (
    <div className={styles.appModule}>
      <div className={`${styles.appModuleSidebar} ${open ? styles.appModuleSidebarOpen : "closed"}`}>
        <div className="bg-secondary pt-7 pb-4 rounded">
          <div className={styles.appModuleCloseSidebar} onClick={() => toggleSidebar(false)}>
            ✖
          </div>
          <h4 className="mb-6 px-4 text-white">{vm.name}</h4>
          <SideMenu vm={vm} />
        </div>
      </div>
      <div className={styles.appModuleContent}>
        <div className={`${styles.appModuleSidebarToggle} navbar-dark`}>
          <Navbar.Toggle onClick={() => toggleSidebar(!open)} />
          <h4 className="pl-4 text-white">{vm.name}</h4>
        </div>
        <div className="bg-white shadow p-4 pt-7 rounded">
          <Observer>{() => <View vm={vm.activeChild} />}</Observer>
        </div>
      </div>
    </div>
  );
});

registerView(ModuleView, TimeChargesViewModel);
registerView(ModuleView, UsersModuleViewModel);
registerView(ModuleView, AdministrationViewModel);
registerView(ModuleView, EnforcementViewModel);
registerView(ModuleView, FinanceViewModel);
